import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { AuthState } from './types';
// eslint-disable-next-line import/no-cycle
import { ApplicationRootState } from '../types';

const selectAuth = (state: ApplicationRootState): AuthState =>
    state.auth || initialState;

export const selectAuthUser = createSelector(
    selectAuth,
    (authState) => authState.context.user
);
